module.exports = __webpack_public_path__ + "_/_/_/node_modules/@reverbdotcom/discovery-ui/images/icons/category-icons/electric-guitars-8c1c730d5966ffb3343b1886a3734eb7.svg";


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/images/icons/category-icons/electric-guitars.svg
// module id = rBQ8
// module chunks = 21 23